// extracted by mini-css-extract-plugin
module.exports = {"title":"te3CX","location":"_1FhDE","location__country":"_1JUAw","location__city":"_29uK4"};